module.exports = __webpack_public_path__ + "static/media/custom_background_middle_left.79d5af50.svg";